module.exports = __webpack_public_path__ + "static/media/arctura.7ecec091.png";